export default __webpack_public_path__ + "static/media/Van31.937b03a0.webp";